import React, { useEffect, useState } from "react";
import Loader from "../../SharedLayouts/Loader";
import { Box } from "@mui/system";
import GridTable from "../../table/gridTable";
import { useDispatch, useSelector } from "react-redux";
import useCurrency from "../../../hooks/useCurrency";
import { getCurrencySymbol } from "../../../Helper/getCurrencySymbol";
import { fetchAllWalletToWallet } from "../../../store/actions/walletToWallet/fetchAllWalletToWallet";

const WalletToWalletTable = () => {
  const dispatch = useDispatch();
  // const [filteredRows, setFilteredRows] = useState([]);
  const [_currency, getAmount] = useCurrency();
  const loading = useSelector((state) => state?.withdrawalRequests?.pending);
  const allWalletToWallet =
    useSelector((state) => state?.withdrawalRequests?.allWalletToWallet) || [];
  const { walletToWalletinfo } = useSelector(
    (state) => state?.withdrawalRequests
  );

  useEffect(() => {
    dispatch(
      fetchAllWalletToWallet({
        failed: () => {},
        cb: () => {},
      })
    );
  }, [dispatch]);

  // useEffect(() => {
  //   if (allWalletToWallet) {
  //     const rows = allWalletToWallet;

  //     setFilteredRows(rows);
  //   }
  // }, [allWalletToWallet, getAmount]);

  const columns = [
    {
      field: "userId",
      headerName: "User ID",
      renderCell: (params) => params.row?.user_id,
    },
    {
      field: "firstName",
      headerName: "First Name",
      width: 150,
      renderCell: (params) => params.row?.user_name?.split(" ")[0],
    },
    {
      field: "lastName",
      headerName: "Last Name",
      width: 150,
      renderCell: (params) => params.row?.user_name?.split(" ")[1],
    },
    {
      field: "email",
      headerName: "Email",
      width: 300,
      renderCell: (params) => params.row?.user_email,
    },
    {
      field: "Base Amount",
      headerName: "Base Amount ($/#)",
      width: 210,
      renderCell: (params) =>
        `${getCurrencySymbol(params.row?.from_currency)} ${getAmount(
          params.row?.original_amount,
          2
        )}`,
    },
    {
      field: "Exchange Rate",
      headerName: "Exchange Rate (#)",
      width: 180,
      renderCell: (params) =>
        `${getCurrencySymbol("NGR")} ${getAmount(
          params.row?.exchange_rate,
          2
        )}`,
    },
    {
      field: "Amount Converted",
      headerName: "Amount Converted ($/#)",
      width: 210,
      renderCell: (params) =>
        `${getCurrencySymbol(params.row?.to_currency)} ${getAmount(
          params.row?.converted_amount,
          2
        )}`,
    },
    {
      field: "Transfer Date",
      headerName: "Transfer Date",
      width: 200,
      renderCell: (params) =>
        new Date(params.row?.conversion_date)?.toDateString(),
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 150,
    //   renderCell: (params) => {
    //     const status = params.row?.status;
    //     return (
    //       <div className="flex">
    //         <div
    //           className="px-3 py-0.5"
    //           style={{
    //             borderRadius: "20px",
    //             marginRight: "10px",
    //             color:
    //               status === "cancelled"
    //                 ? "#B42318"
    //                 : status === "processing"
    //                 ? "#9b6700"
    //                 : "green",
    //             backgroundColor:
    //               status === "approved"
    //                 ? "#00800052"
    //                 : status === "Processing"
    //                 ? "#aea22d30"
    //                 : status === "cancelled"
    //                 ? "#f5f0f0"
    //                 : "",
    //           }}
    //         >
    //           {status === "pending"
    //             ? "Pending"
    //             : status === "cancelled"
    //             ? "Cancelled"
    //             : status === "approved"
    //             ? "Approved"
    //             : "Processing"}
    //         </div>
    //       </div>
    //     );
    //   },
    // },
  ];

  return (
    <div className="mt-10 mb-8">
      <div className="bg-white">
        {!loading ? (
          <Box sx={{ overflowX: "auto", width: "100%", cursor: "pointer" }}>
            <GridTable
              type={"walletToWallet"}
              rows={allWalletToWallet}
              columns={columns}
              pageInfo={walletToWalletinfo}
              getRowId={(row) => row.conversion_date}

              // onRowClick={handleRowClick}
            />
          </Box>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default WalletToWalletTable;
